import { render, staticRenderFns } from "./CreditHistory.vue?vue&type=template&id=4974b2a1&"
import script from "./CreditHistory.vue?vue&type=script&lang=js&"
export * from "./CreditHistory.vue?vue&type=script&lang=js&"
import style0 from "./CreditHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports